import { FC } from 'react';

import List from './List';
import { TypeAheadOption } from '..';

// Local Typings
interface Props {
  currentInputValue: string;
  dropdownPositionTop?: number;
  hideDropdownIfNoResults: boolean;
  onBlur: (evt: React.FocusEvent<HTMLUListElement>) => void;
  onFocus: (evt: React.FocusEvent<HTMLUListElement>) => void;
  onSelect: (option: TypeAheadOption) => void;
  options: TypeAheadOption[];
  showDropdownOnEmptyInput: boolean;
}

// Component Definition
const Dropdown: FC<Props> = ({
  currentInputValue,
  hideDropdownIfNoResults,
  options,
  ...props
}) => {
  const hasInputValue = currentInputValue.trim().length > 0;
  const hasResults = options.length > 0;
  const hideForEmptyInput = !hasInputValue && !props.showDropdownOnEmptyInput;
  const hideForNoResults = hideDropdownIfNoResults && !hasResults;

  if (hideForEmptyInput || hideForNoResults) {
    return null;
  }

  return (
    <List
      onBlur={props.onBlur}
      onFocus={props.onFocus}
      onSelect={props.onSelect}
      options={options}
      top={props.dropdownPositionTop}
    />
  );
};

export default Dropdown;
